import * as React from "react";
import { Outlet } from "react-router-dom";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { IconButton, Stack, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
function ToolbarActionsSearch() {
  const navigate = useNavigate();

  return (
    <Stack direction="row">
      <Tooltip title="Home">
        <IconButton
          onClick={() => navigate("/")}
          color="primary"
          sx={{
            bgcolor: "primary.light",
            "&:hover": { bgcolor: "primary.main", color: "common.white" },
          }}
        >
          <HomeIcon sx={{ fontSize: 28 }} />
        </IconButton>
      </Tooltip>
      {/* <Tooltip title="equipment">
        <IconButton onClick={() => navigate("/equipment")}>
          <SettingsIcon />
        </IconButton>
      </Tooltip> */}
    </Stack>
  );
}

export default function Layout() {
  return (
    <DashboardLayout
      hideNavigation
      slots={{
        toolbarActions: ToolbarActionsSearch,
      }}
    >
      <Outlet />
    </DashboardLayout>
  );
}
